import { NavIdsEnum } from '@components/header-landing/constants';
import Icon from '@components/icons';
import * as Styles from '@screens/lp-default/components/hero/styles';
import { useHandleLPScroll } from '@screens/hooks/use-handle-lp-scroll';
import { snowplowButtonClick } from '@analytics/snowplow/events';

type Props = {
  id: string;
};

export default function HeroDefault({ id }: Props) {
  const { handleScrollTo } = useHandleLPScroll();

  const handleButtonClick = () => {
    snowplowButtonClick('want_know', '/planos', 'journey_section', 'hero');
    handleScrollTo(NavIdsEnum.TOOLS);
  };

  return (
    <Styles.HeroContainer id={id} data-testid="hero">
      <Styles.HeroOverlay />
      <Styles.HeroBackground>
        <source media="(max-width: 1023px)" srcSet="/images/default-landing-page/hero-tablet.webp" />
        <source media="(max-width: 663px)" srcSet="/images/default-landing-page/hero-mobile.webp" />
        <img src="/images/default-landing-page/hero-tablet.webp" alt="Médica consultando o Whitebook pelo celular" />
      </Styles.HeroBackground>
      <Styles.HeroVideoBackground autoPlay muted loop>
        <source src="/images/default-landing-page/hero-desktop.mp4" type="video/mp4" />
      </Styles.HeroVideoBackground>
      <Styles.HeroContent>
        <Styles.HeroSubtitle isDesktopExclusive>Afya Whitebook</Styles.HeroSubtitle>
        <Styles.HeroTitle>Solução #1 para decisões clínicas do Brasil</Styles.HeroTitle>
        <Styles.HeroSubtitle>
          Conteúdos baseados em evidências científicas. Com você da graduação à prática médica!
        </Styles.HeroSubtitle>
        <Styles.HeroButton onClick={handleButtonClick}>
          Saiba mais <Icon icon="arrow-down" size={20} />
        </Styles.HeroButton>
      </Styles.HeroContent>
    </Styles.HeroContainer>
  );
}
